import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";
import { cn } from "@/lib/utils";
import { ICON_ONLY_HEADER_LINKS } from "@/lib/const";

export interface ViewToggleProps {
  className?: string;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ className }) => {
  const { shopId } = useParams();
  const location = useLocation();

  if (!shopId) {
    return null;
  }

  // Determine current view based on the current route
  const isListView = location.pathname.includes("dashboard-list");
  const isGridView = location.pathname === `/${shopId}` && !isListView;

  // Only show on dashboard pages
  if (!isGridView && !isListView) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex h-9 items-center rounded-md border border-slate-300 bg-slate-200 p-px",
        className
      )}
    >
      <Link to={`/${shopId}`} className="block">
        <Button
          variant={isGridView ? "default" : "ghost"}
          size={ICON_ONLY_HEADER_LINKS ? "smIcon" : "sm"}
          className={cn(
            "size-8 transition-all",
            !ICON_ONLY_HEADER_LINKS && "px-3",
            isGridView
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
          aria-label="Grid View"
        >
          <Icon name={IconNames.layouts} size={20} />
          {!ICON_ONLY_HEADER_LINKS && (
            <span className="ml-2 text-sm font-semibold">Grid</span>
          )}
        </Button>
      </Link>

      <Link to={`/${shopId}/dashboard-list`} className="block">
        <Button
          variant={isListView ? "default" : "ghost"}
          size={ICON_ONLY_HEADER_LINKS ? "smIcon" : "sm"}
          className={cn(
            "size-8 transition-all",
            !ICON_ONLY_HEADER_LINKS && "px-3",
            isListView
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
          aria-label="List View"
        >
          <Icon name={IconNames.list} size={20} />
          {!ICON_ONLY_HEADER_LINKS && (
            <span className="ml-2 text-sm font-semibold">List</span>
          )}
        </Button>
      </Link>
    </div>
  );
};
